<breadcrumb-navigation [titles]="[{ key: 'MY_CONSENT', url: ''}, { key: 'PRIVACY_TERMS_OF_USE', url: ''}]"></breadcrumb-navigation>
<div class="data-protection-policy">
  <div>
    <div class="title sm:text-3xl sm:items-baseline">{{ title }}</div>
    <div class="sub-title sm:text-lg">{{ "Data_PROTECTION_POLICY_BY_COMPANY" | translate }}</div>
  </div>
  <nz-tabset  [nzSelectedIndex]="selectedIndex" (nzSelectChange)="handleChangeTabset($event)">
    <nz-tab [nzTitle]="'CORPORATE' | translate" class="sm:text-lg">
      <cooperate-information></cooperate-information>
    </nz-tab>
    <nz-tab [nzTitle]="'Data_PROTECTION_POLICY' | translate">
      <privacy-statement></privacy-statement>
    </nz-tab>
  </nz-tabset>
</div>
